import request from '@/util/request'


export const trainList = (data) => request.post('/api/trainList', data);  //查找培训记录

export const trainDetail = (data) => request.post('/api/trainDetail', data);  //培训记录详情